import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Input } from "../../../base/input/input";
import { useDebouncedDateRangeFilter } from "./hooks";
/**
 * Date range filter for DataTable columns
 *
 * @example
 * ```tsx
 * <DataTableDateRangeFilter
 *   column={column}
 * />
 * ```
 */ export function DataTableDateRangeFilter({ column }) {
    const { t } = useTranslation();
    const { fromDate, setFromDate, toDate, setToDate } = useDebouncedDateRangeFilter(column);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ _jsx(Input, {
                type: "date",
                value: fromDate,
                onChange: (e)=>setFromDate(e.target.value),
                placeholder: t("dataTable.filters.from"),
                className: "h-8 w-[130px]"
            }),
            /*#__PURE__*/ _jsx(Input, {
                type: "date",
                value: toDate,
                onChange: (e)=>setToDate(e.target.value),
                placeholder: t("dataTable.filters.to"),
                className: "h-8 w-[130px]"
            })
        ]
    });
}

//# sourceMappingURL=DataTableDateRangeFilter.js.map